import axios from '@/axios';
import swal from 'sweetalert2';
import router from '@/routes/router';


const state = {
    sites: {
        docs: []
    },
    loading: false, 
    site: null,
    attachmentLoading: false,
};

const actions = {
    async getAll({ commit,dispatch } , options) {
        commit('getAllRequest');
        return new Promise(async (resolve, reject) => {
            const opt = {
                page: 1,
                limit: 400,
                ...options
            }
            try{
                const res = await axios.get(`/api/sites?page=${opt.page}&limit=${opt.limit}`)
                commit('getAllSuccess', res.data);
                resolve(res.data);
            } catch(e){
                commit('getAllFailure', e);
                dispatch('alert/error', e, { root: true });
                reject(e);
            };
        })
    },

    async get({ commit,dispatch }, id) {
        commit('getRequest');
        try{
            const res = await axios.get(`/api/sites/${id}`)
            commit('getSuccess', res.data);
        } catch(e){
            commit('getFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    async update({ commit,dispatch }, site) {
        commit('updateRequest', site);
        try{
            const res = await axios.put(`/api/sites/${site.id}`,{site})
            commit('updateSuccess', res.data);
            dispatch('alert/success', 'Cantiere modificato correttamente', { root: true });
        } catch(e){
            commit('updateFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    async create({ commit,dispatch }, site) {
        commit('createRequest', site);
        try{
            const res = await axios.post(`/api/sites`,{site})
            commit('createSuccess', res.data);
            dispatch('alert/success', 'Cantiere creato correttamente', { root: true });
            setTimeout(() => {router.push(`/sites/${res.data.id}`) },500);
        } catch(e){
            commit('createFailure', e);
            dispatch('alert/error', e, { root: true });
        };
    },

    async delete({ commit,dispatch }, id) {
        const confirm = await swal.fire({
            title: 'Sicuro?',
            // text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Elimina elemento',
            cancelButtonText: 'Annulla',
            reverseButtons: true
        })

        if (confirm.value) {
            commit('deleteRequest', id);
            try{
                const data = await axios.delete(`/api/sites/${id}`)
                dispatch('alert/success', 'Cantiere rimosso correttamente', { root: true });
                commit('deleteSuccess', id);
            } catch(e){
                commit('deleteFailure', e);
                dispatch('alert/error', e, { root: true });
                
            };
        }
    },

    async addAttachment({ commit, dispatch },{siteId,attachment}) {
        commit('addAttachmentRequest');
        const formData = new FormData();
        formData.append("attachment", attachment);

        try{
            const res = await axios.post(`/api/sites/${siteId}/site-attachments`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            dispatch('alert/success', 'File caricato correttamente', { root: true });
            commit('addAttachmentSuccess', res.data);
        } catch(e){
            commit('addAttachmentFailure', e);
            dispatch('alert/error', e, { root: true });
            
        };        
    },


    async updateAttachment({ commit, dispatch },{siteId, id, siteAttachment}) {
        commit('updateAttachmentRequest');
        try{
            const res = await axios.put(`/api/sites/${siteId}/site-attachments/${id}`,
                {siteAttachment})
            dispatch('alert/success', 'File modificato correttamente', { root: true });
            commit('updateAttachmentSuccess', res.data);
        } catch(e){
            commit('updateAttachmentFailure', e);
            dispatch('alert/error', e, { root: true });
        };        
    },


    async deleteAttachment({ commit, dispatch },{siteId,id}) {

        const confirm = await swal.fire({
            title: 'Sicuro?',
            // text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Elimina elemento',
            cancelButtonText: 'Annulla',
            reverseButtons: true
        })

        if (confirm.value) {
            commit('removeAttachmentRequest');
            try{
                const data = await axios.delete(`/api/sites/${siteId}/site-attachments/${id}`)
                dispatch('alert/success', 'Cantiere rimosso correttamente', { root: true });
                commit('removeAttachmentSuccess', id);
            } catch(e){
                commit('removeAttachmentFailure', e);
                dispatch('alert/error', e, { root: true });
                
            };
        }
    }
};

const mutations = {
    getAllRequest(state) {
        state.loading = true;
        state.sites.docs = [];
    },
    getAllSuccess(state, sites) {
        state.sites = sites;
        state.loading = false;
    },
    getAllFailure(state, error) {
        state.error = error;
        state.loading = false;
    },
    updateRequest(state, site) {
        state.site = {
            ...site,
            loading: true
        };
    },
    updateSuccess(state, newSite) {
        state.sites.docs = state.sites.docs.map(site => (site.id === newSite.id ? newSite : site))
        state.site = newSite;
    },
    updateFailure(state, error) {        
        state.site = { ...state.site, error };
    },
    deleteRequest(state, id) {
        state.sites.docs = state.sites.docs.map(site =>
            site.id === id
                ? { ...site, deleting: true }
                : site
        )
    },
    deleteSuccess(state, id) {
        // remove deleted site from state
        state.sites.docs = state.sites.docs.filter(site => site.id !== id)
    },
    deleteFailure(state, { id, error }) {
        // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
        state.sites.docs = state.sites.docs.map(site => {
            if (site.id === id) {
                // make copy of site without 'deleting:true' property
                const { deleting, ...siteCopy } = site;
                // return copy of site with 'deleteError:[error]' property
                return { ...siteCopy, deleteError: error };
            }

            return site;
        })
    },
    createRequest(state) {
        state.loading = true;
    },
    createSuccess(state, site) {
        state.loading = false;
        state.site = site;
    },
    createFailure(state, e) {
        state.loading= false;
    },
    getRequest(state) {
        state.loading = true;
    },
    getSuccess(state, site) {
        state.loading = false;
        state.site = site;
    },
    getFailure(state) {
        state.loading = false;
    },
    addAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    addAttachmentSuccess(state,attachment) {
        state.attachmentLoading = false;
        state.site.attachments.push(attachment);
    },
    addAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    updateAttachmentSuccess(state) {
        state.attachmentLoading = false;
    },
    updateAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
    removeAttachmentRequest(state) {
        state.attachmentLoading = true;
    },
    removeAttachmentSuccess(state,attachmentId) {
        state.attachmentLoading = false;
        state.site.attachments = state.site.attachments.filter(att => att.id !== attachmentId)
    },
    removeAttachmentFailure(state) {
        state.attachmentLoading = false;
    },
};

export const sites = {
    namespaced: true,
    state,
    actions,
    mutations
};